import { IBaseVraagboomResultaat } from './base.vraagboom.resultaat';

export class VraagboomUploadResultaat implements IBaseVraagboomResultaat {
  uploadedFiles: Uploadfile[];

  constructor() {
    this.uploadedFiles = [];
  }
}

export class Uploadfile {
  constructor(
    public name: string,
    public type: string,
    public dataUrl: string,
    public groepId: string,
    public antwoordId: string
  ) { }

  public get blob(): string {
    if (this.dataUrl == null) {
      return this.dataUrl;
    }

    // First approach was to use regex but with large image this can decrease performance
    const index = this.dataUrl.indexOf('base64,');
    if (index >= 0) {
      return this.dataUrl.substring(index + 7);
    }
    return this.dataUrl;
  }
}
